// import { LocalStorageData } from "libs/models";
import jwtDecode from "jwt-decode";
import { Get as ExpoGet, Save, Clear } from "./expo.store.service";

const GetToken = function () {
  const TokenPromise = new Promise<string>((resolve, reject) => {
    ExpoGet("TOKEN")
      .then((result) => resolve(result))
      .catch((err) => reject(null));
  });
  return TokenPromise;
};

const SetTokens = function (token: string, refreshToken: string) {
  return [Save("TOKEN", token), Save("REFRESH_TOKEN", refreshToken)];
};

const ClearCredentials = function () {
  return Promise.all([Clear("TOKEN"), Clear("REFRESH_TOKEN")]);
};

const HasValidToken = (token: string) => {
  if (!token) {
    return false;
  }
  let flag = false;

  try {
    const time = Math.trunc(Date.now() / 1000); //returns Integer part
    const decoded: Record<string, number> = jwtDecode(token);
    if (decoded && decoded.exp > time) flag = true;
  } catch (error) {
    alert("Token Error / No Token Found");
  }
  return flag;
};
// const GetRefreshToken = function () {
//   return localStorage.getItem("REFRESH_TOKEN");
// };
// const GetUser = function () {
//   let user = localStorage.getItem("USER");
//   if (user) return JSON.parse(user);
//   return null;
// };
// const SetUser = function (user: string) {
//   localStorage.setItem("USER", user);
// };

export {
  GetToken,
  SetTokens,
  // SetUser,
  // GetUser,
  // GetRefreshToken,
  HasValidToken,
  ClearCredentials,
};
